import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconGutterVertical12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconGutterVertical12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 11a.5.5 0 0 1-.5-.5.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.501.5.5 0 0 1-1 0A1.5 1.5 0 0 1 2.5 9h7a1.5 1.5 0 0 1 1.5 1.5.5.5 0 0 1-.5.5m-9-10a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5.5.5 0 1 1 1 0A1.5 1.5 0 0 1 9.5 3h-7A1.5 1.5 0 0 1 1 1.5a.5.5 0 0 1 .5-.5M9 6.5a.5.5 0 0 0 0-1H3a.5.5 0 1 0 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconGutterVertical12);
